import React, { PureComponent } from 'react';

import { Formik, Form } from 'formik';
import * as Yup from "yup";

import {
  StyledFormWrapper,
  StyledFormField,
  StyledFormFieldWrapper,
  StyledMessageBox,
  StyledFormButton,
  StyledFormCommunicat,
  StyledPlaceDescription,
  StyledFormLabel,
  StyledFormCheckbox,
} from './invoiceForm.style';

import { StyledElementWrapperCenter } from 'styledElements';

// Texts
import text from 'i18l';


const Schema = Yup.object().shape({
  name: Yup.string()
    .required('Wymagane'),
  email: Yup.string()
    .email('Niepoprawny e-mail')
    .required('Wymagane'),
  phone: Yup.string()
    .required('Wymagane'),
  value: Yup.string()
    .required('Wymagane'),
  hour: Yup.string()
    .required('Wymagane'),
  number: Yup.string()
    .required('Wymagane'),
  companyName: Yup.string()
    .required('Wymagane'),
  place: Yup.string()
    .required('Wymagane'),
  companyAddress: Yup.string()
    .required('Wymagane'),
  companyPostCode: Yup.string()
    .required('Wymagane'),
  companyCity: Yup.string()
    .required('Wymagane'),
  companyNip: Yup.string()
    .required('Wymagane'),
  policy: Yup.bool().oneOf([true], 'Wymagane'),
});

class InvoiceForm extends PureComponent {

  returnMessage = (values) => `
        <div>
            <div><strong>Kwota mycia</strong></div>
            <div>${values.value}</div>
            <div><strong>Data</strong></div>
            <div>${values.hour}</div
            <div><strong>Stanowisko</strong></div>
            <div>${values.place}</div
            <div><strong>Numer rejestracyjny</strong></div>
            <div>${values.number}</div<br/><br/>
            <div><strong>Dane kontaktowe</strong></div>
            <div><strong>Imię i nazwisko</strong></div>
            <div>${values.name}</div>
            <div><strong>Numer telefonu</strong></div>
            <div>${values.phone}</div>
            <div><strong>Adres e-mail</strong></div>
            <div>${values.email}</div><br/><br/>
            <div><strong>Dane do faktury</strong></div>
            <div><strong>Nazwa firmy</strong></div>
            <div>${values.companyName}</div>
            <div><strong>Adres firmy</strong></div>
            <div>${values.companyAddress}</div>
            <div><strong>Kod pocztowy firmy</strong></div>
            <div>${values.companyPostCode}</div>
            <div><strong>Miasto</strong></div>
            <div>${values.companyCity}</div>
            <div><strong>Numer NIP</strong></div>
            <div>${values.companyNip}</div>
        </div>
    `;

  sendMail = (values) => {
    const data = {
      message: this.returnMessage(values) ,
      formName: "Formularz FAKTURA VAT",
    };

    this.props.invoiceFormRequest(data);
  };

  renderFormCommunicat = () => {
    const { invoiceFormSuccess, invoiceFormFailure } = this.props;
    if (invoiceFormSuccess) {
      return <StyledFormCommunicat success>{text.INVOICE.SUCCESS}</StyledFormCommunicat>
    }
    if (invoiceFormFailure) {
      return <StyledFormCommunicat>{text.INVOICE.FAILURE}</StyledFormCommunicat>
    }
  };

  render() {
    return (
        <StyledElementWrapperCenter>
          {this.renderFormCommunicat()}
          <StyledFormWrapper>
            <Formik
              initialValues={{
                name: '',
                email: '',
                phone: '',
                value: '',
                number: '',
                place: '',
                hour: '',
                companyName: '',
                companyAddress: '',
                companyPostCode: '',
                companyCity: '',
                companyNip: '',
                policy: false,
              }}
              validationSchema={Schema}
              onSubmit={(values, {resetForm}) => {resetForm(); this.sendMail(values);}}
            >
              {({ errors, touched, values }) => (
                <Form>
                  <h3>Twoje dane kontaktowe</h3>
                  <StyledFormFieldWrapper>
                    <StyledFormField placeholder="Imię i nazwisko" name="name"  />
                    {errors.name && touched.name ? (
                      <StyledMessageBox>{errors.name}</StyledMessageBox>
                    ) : null}
                  </StyledFormFieldWrapper>

                  <StyledFormFieldWrapper>
                    <StyledFormField placeholder="Adres email" name="email" type="email" />
                    {errors.email && touched.email ? (
                      <StyledMessageBox>{errors.email}</StyledMessageBox>
                    ) : null}
                  </StyledFormFieldWrapper>

                  <StyledFormFieldWrapper>
                    <StyledFormField placeholder="Numer telefonu" name="phone" type="phone" />
                    {errors.phone && touched.phone ? (
                      <StyledMessageBox>{errors.phone}</StyledMessageBox>
                    ) : null}
                  </StyledFormFieldWrapper>

                  <h3>Dane potrzebne do zidentyfikowania płatności</h3>
                  <StyledFormFieldWrapper>
                    <StyledFormField placeholder="Kwota mycia" name="value" />
                    {errors.value && touched.value ? (
                      <StyledMessageBox>{errors.value}</StyledMessageBox>
                    ) : null}
                  </StyledFormFieldWrapper>
                  <StyledFormFieldWrapper>
                    <StyledFormField placeholder="Numer rejestracyjny samochodu" name="number" />
                    {errors.number && touched.number ? (
                      <StyledMessageBox>{errors.number}</StyledMessageBox>
                    ) : null}
                  </StyledFormFieldWrapper>
                  <StyledFormFieldWrapper>
                    <StyledFormField placeholder="Data i godzina mycia" name="hour" />
                    {errors.hour && touched.hour ? (
                      <StyledMessageBox>{errors.hour}</StyledMessageBox>
                    ) : null}
                  </StyledFormFieldWrapper>
                  <StyledFormFieldWrapper>
                    <StyledFormField placeholder="Numer stanowiska" name="place" />
                    {errors.place && touched.place ? (
                      <StyledMessageBox>{errors.place}</StyledMessageBox>
                    ) : null}
                    <StyledPlaceDescription>{text.INVOICE.PLACE_DESCRIPTION}</StyledPlaceDescription>
                  </StyledFormFieldWrapper>


                  <h3>Dane do faktury</h3>
                      <StyledFormFieldWrapper>
                        <StyledFormField placeholder="Nazwa firmy" name="companyName"  />
                        {errors.companyName && touched.companyName ? (
                          <StyledMessageBox>{errors.companyName}</StyledMessageBox>
                        ) : null}
                      </StyledFormFieldWrapper>
                      <StyledFormFieldWrapper>
                        <StyledFormField placeholder="Adres firmy" name="companyAddress"  />
                        {errors.companyAddress && touched.companyAddress ? (
                          <StyledMessageBox>{errors.companyAddress}</StyledMessageBox>
                        ) : null}
                      </StyledFormFieldWrapper>
                      <StyledFormFieldWrapper>
                        <StyledFormField placeholder="Kod pocztowy" name="companyPostCode"  />
                        {errors.companyPostCode && touched.companyPostCode ? (
                          <StyledMessageBox>{errors.companyPostCode}</StyledMessageBox>
                        ) : null}
                      </StyledFormFieldWrapper>
                      <StyledFormFieldWrapper>
                        <StyledFormField placeholder="Miasto" name="companyCity"  />
                        {errors.companyCity && touched.companyCity ? (
                          <StyledMessageBox>{errors.companyCity}</StyledMessageBox>
                        ) : null}
                      </StyledFormFieldWrapper>
                      <StyledFormFieldWrapper>
                        <StyledFormField placeholder="Numer NIP" name="companyNip"  />
                        {errors.companyNip && touched.companyNip ? (
                          <StyledMessageBox>{errors.companyNip}</StyledMessageBox>
                        ) : null}
                      </StyledFormFieldWrapper>
                  <StyledFormFieldWrapper>
                    <StyledFormLabel data-reactid=".1.0.0">
                      <StyledFormCheckbox name="policy"  data-reactid=".1.0.0" type="checkbox" />
                      <span>Wypełnienie formularza oznacza, że podane w nim dane osobowe będą przetwarzane w celu przesłania oferty oraz kontaktu w jej sprawie. Zasady przetwarzania i informacje o administratorze znajdziesz <a href="/polityka-prywatnosci.pdf" target="_blank">tutaj</a>.</span>
                      {errors.policy && touched.policy ? (
                        <StyledMessageBox>{errors.policy}</StyledMessageBox>
                      ) : null}
                    </StyledFormLabel>

                  </StyledFormFieldWrapper>
                  <StyledFormButton type="submit">ZAMÓW FAKTURĘ VAT &raquo;</StyledFormButton>
                </Form>
              )}
            </Formik>
          </StyledFormWrapper>
        </StyledElementWrapperCenter>
    );
  }
}

export default InvoiceForm;


// WEBPACK FOOTER //
// ./src/components/invoiceForm/invoiceForm.component.js